/**
 * Владелец судна в карточке: что показать и с какой оговоркой.
 *
 * Поле «Юр.лицо» карточки — это `company_key`, ручной справочник, которым живут
 * фильтр «Свой флот» и анонимность мест вылова; на 15.08.2026 он заполнен у 15
 * судов из 94 968. Рядом теперь едет ВЛАДЕЛЕЦ, и он приходит из двух источников
 * разного качества:
 *
 * * `f58` — квотодержатель донесений: русское имя юр.лица, свои данные;
 * * `gfw` — реестр Global Fishing Watch: латиница, зато любой флаг. Запись
 *   реестра ИМЕЕТ СРОК, и у половины судов он закрыт прошлым годом.
 *
 * Отсюда оговорка. «PACIFIC OCEAN FISHING» без пояснения читается как «владеет
 * сейчас», хотя реестр утверждает лишь, что владел по такой-то год. Эта разница
 * и есть причина, по которой владелец не пишется в `company_key`: там значение
 * означает «это судно нашей организации», и ошибка стоила бы чужих точек лова в
 * чужом кабинете.
 *
 * Функция чистая и возвращает КЛЮЧ, а не фразу: слова подставляет компонент
 * (кабинет двуязычный, и вторая копия каталога переводов нам не нужна).
 */

export interface OwnerRow {
  /** Имя владельца или прочерк — готово к показу. */
  value: string
  /** Ключ оговорки под именем; null — оговорка не нужна. */
  noteKey: string | null
  /** Подстановки оговорки (год записи реестра). */
  noteParams?: { year: number }
}

const DASH = '—'

function year(value: unknown): number | null {
  if (typeof value !== 'string') return null
  const ts = Date.parse(value)
  return Number.isNaN(ts) ? null : new Date(ts).getUTCFullYear()
}

export function ownerRow(props: Record<string, unknown>): OwnerRow {
  const owner = typeof props.owner === 'string' && props.owner.trim() ? props.owner : null
  if (!owner) return { value: DASH, noteKey: null }

  // Имя из донесений и правка человека говорят сами за себя: оговорка была бы
  // шумом на каждой карточке своего флота.
  if (props.owner_source !== 'gfw') return { value: owner, noteKey: null }

  const to = year(props.owner_to)
  return to === null
    ? { value: owner, noteKey: 'models.vessel.ownerRegistryNoDate' }
    : { value: owner, noteKey: 'models.vessel.ownerRegistry', noteParams: { year: to } }
}
